import React, { useState } from 'react';
import { confirmSignUp, resendSignUpCode, autoSignIn } from '../auth';
import { fetchUserProfile, cacheProfile } from '../api/users';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, TextField, Typography, Alert } from '@mui/material';

export default function ConfirmEmailPage() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [resent, setResent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const navigate = useNavigate();
  const { t } = useTranslation();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await confirmSignUp({ username: email, confirmationCode: code });
      try {
        await autoSignIn();
        const profile = await fetchUserProfile();
        cacheProfile(profile);
        navigate(profile.profileComplete ? '/catalog' : '/profile');
      } catch {
        navigate('/login');
      }
    } catch (err) {
      setError(err.message || 'Confirmation failed');
      setLoading(false);
    }
  }

  async function handleResend() {
    setError('');
    setResent(false);
    try {
      await resendSignUpCode({ username: email });
      setResent(true);
    } catch (err) {
      setError(err.message || 'Failed to resend code');
    }
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 400, mx: 'auto', mt: 8, p: 3 }}>
      <Typography variant="h5" mb={1}>{t('confirmEmail.title')}</Typography>
      <Typography variant="body2" mb={3} color="text.secondary">
        {t('confirmEmail.subtitle', { email })}
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {resent && <Alert severity="success" sx={{ mb: 2 }}>{t('confirmEmail.resent')}</Alert>}
      <TextField label={t('confirmEmail.code')} fullWidth required
        value={code} onChange={e => setCode(e.target.value)} sx={{ mb: 3 }} disabled={loading} />
      <Button type="submit" variant="contained" fullWidth disabled={loading}>
        {loading ? t('confirmEmail.submitting') : t('confirmEmail.submit')}
      </Button>
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
        <Button type="button" variant="text" size="small" onClick={handleResend} disabled={loading}>{t('confirmEmail.resend')}</Button>
        <Link to="/login">{t('confirmEmail.backToSignIn')}</Link>
      </Box>
    </Box>
  );
}
